package com.eladfinish.bible.contest.screens.browse.contentOfChapter.ui.dialogs

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.constants.strings.aliyotParasha
import com.eladfinish.bible.contest.ui.components.dialogs.AlternateRowColorsDialog
import com.eladfinish.bible.contest.ui.components.dialogs.BasicDialogWithTitle
import kotlinx.collections.immutable.toImmutableList

@Composable
internal fun ChooseAliyahDialog(
    title: String,
    onItemClick: (String) -> Unit,
    onDismiss: () -> Unit,
) {
    BasicDialogWithTitle(
        title = title,
        onDismiss = onDismiss,
        onCancel = onDismiss,
    ) {
        AlternateRowColorsDialog(
            items = aliyotParasha.toImmutableList(),
            itemAsString = { it },
            onItemClick = { _, aliyah ->
                onDismiss()
                onItemClick(aliyah)
            },
        )
    }
}
